var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOngoingShipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3161 4.17165C12.1108 4.09921 11.8889 4.09921 11.6836 4.17165L6.16222 6.12011L11.9999 8.18016L17.8375 6.12011L12.3161 4.17165ZM3.99997 16.0187V7.58892L10.9999 10.0591V19.3123L3.99997 16.0187ZM12.9999 19.3123L19.9998 16.0187V7.58892L12.9999 10.0591V19.3123ZM21.9997 16.7067V6.14481C22.0017 6.05684 21.9932 5.9675 21.9734 5.87865C21.9608 5.82132 21.9437 5.76558 21.9225 5.71191C21.8481 5.52289 21.7266 5.36745 21.5775 5.25594C21.5179 5.21127 21.4532 5.17315 21.384 5.14273C21.3581 5.13128 21.3317 5.12098 21.3049 5.11186L12.9485 2.16298C12.3327 1.94567 11.667 1.94567 11.0512 2.16298L2.68376 5.11577C2.27543 5.25987 2 5.66443 2 6.12011V16.7067C2 17.1251 2.23273 17.5042 2.59385 17.6741L11.5937 21.9088C11.8523 22.0304 12.1474 22.0304 12.406 21.9088L21.4059 17.6741C21.767 17.5042 21.9997 17.1251 21.9997 16.7067Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOngoingShipment);
export default __webpack_public_path__ + "static/media/ongoing_shipment.b4ab20f79281eea1ba24bbabecaab206.svg";
export { ForwardRef as ReactComponent };